import HttpService from "./HttpService";

let configuracaoService = {
  consultar: () => {
    return HttpService.backApi.get("/config");
  },
  salvar: (body) => {
    return HttpService.backApi.post("/config", body);
  },
};

export default configuracaoService;
